/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateYoutubeVideoConfigReqVo
 */
export interface CreateYoutubeVideoConfigReqVo {
    /**
     * 缩略图OSS地址
     * @type {string}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    thumbnailUrl: string;
    /**
     * YouTube原始完整视频链接
     * @type {string}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    videoUrl: string;
    /**
     * 视频标题（韩文）
     * @type {string}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    titleKr: string;
    /**
     * 视频标题（中文）
     * @type {string}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    titleCn: string;
    /**
     * 视频简介（韩文）
     * @type {string}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    descriptionKr?: string;
    /**
     * 视频简介（中文）
     * @type {string}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    descriptionCn?: string;
    /**
     * 展示排序，数值越小越靠前；未删除记录中不可重复，不传则按库默认值 0
     * 展示排序，数值越小越靠前；未删除记录中不可重复
     * @type {number}
     * @memberof CreateYoutubeVideoConfigReqVo
     */
    sortNo?: number;
}

/**
 * Check if a given object implements the CreateYoutubeVideoConfigReqVo interface.
 */
export function instanceOfCreateYoutubeVideoConfigReqVo(value: object): value is CreateYoutubeVideoConfigReqVo {
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('videoUrl' in value) || value['videoUrl'] === undefined) return false;
    if (!('titleKr' in value) || value['titleKr'] === undefined) return false;
    if (!('titleCn' in value) || value['titleCn'] === undefined) return false;
    return true;
}

export function CreateYoutubeVideoConfigReqVoFromJSON(json: any): CreateYoutubeVideoConfigReqVo {
    return CreateYoutubeVideoConfigReqVoFromJSONTyped(json, false);
}

export function CreateYoutubeVideoConfigReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateYoutubeVideoConfigReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'thumbnailUrl': json['thumbnailUrl'],
        'videoUrl': json['videoUrl'],
        'titleKr': json['titleKr'],
        'titleCn': json['titleCn'],
        'descriptionKr': json['descriptionKr'] == null ? undefined : json['descriptionKr'],
        'descriptionCn': json['descriptionCn'] == null ? undefined : json['descriptionCn'],
        'sortNo': json['sortNo'] == null ? undefined : json['sortNo'],
    };
}

export function CreateYoutubeVideoConfigReqVoToJSON(json: any): CreateYoutubeVideoConfigReqVo {
    return CreateYoutubeVideoConfigReqVoToJSONTyped(json, false);
}

export function CreateYoutubeVideoConfigReqVoToJSONTyped(value?: CreateYoutubeVideoConfigReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thumbnailUrl': value['thumbnailUrl'],
        'videoUrl': value['videoUrl'],
        'titleKr': value['titleKr'],
        'titleCn': value['titleCn'],
        'descriptionKr': value['descriptionKr'],
        'descriptionCn': value['descriptionCn'],
        'sortNo': value['sortNo'],
    };
}

